// utils/useFavicon.ts
import { useEffect } from 'react';

export const useFavicon = (url: string) => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = url;

    if (url.endsWith('.svg')) {
      link.type = 'image/svg+xml';
      link.setAttribute('sizes', 'any');
    }

    const existingLinks = document.querySelectorAll("link[rel~='icon']");
    existingLinks.forEach(el => el.remove());

    document.head.appendChild(link);
  }, [url]);
};
